
import styled, { DefaultTheme } from "styled-components";
import { lighten, darken, readableColor } from "polished";

import { Colors } from "../types";

interface IButtonProps {
  block?: boolean;
  color?: keyof Colors;
  theme: DefaultTheme;
};

const contrastUp = 0.15;
const contrastDown = 0.15;

export const Button = styled.button.attrs((props: IButtonProps) => ({
  color: props.theme.colors[props.color || "primary"],
  block: props.block
}))`
  display: ${(props: any) => (props.block ? "block" : "inline-block")};
  width: ${(props: any) => (props.block ? "100%" : "auto")};
  cursor: pointer;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: ${props => props.theme.sizes.small}rem;
  height: ${props => props.theme.sizes.huge}rem;
  transition: background-color ${props => props.theme.transitions.quick} ease,
    color ${props => props.theme.transitions.quick} ease,
    border ${props => props.theme.transitions.quick} ease;
  padding: 0 ${props => props.theme.sizes.normal}rem;
  font-size: 1rem;
  font-weight: 500;
  border: 2px solid transparent; // Don't know why this is needed to make the buttons same sized..
  background-color: ${(props: any) => props.color};
  color: ${(props: any) => readableColor(props.color)};
  &:hover {
    background-color: ${(props: any) => lighten(contrastDown, props.color)};
  }

  &:active {
    background-color: ${(props: any) => darken(contrastUp, props.color)};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${(props: any) => props.color};
  }
`;

export const BorderButton = styled(Button)`
  background-color: transparent;
  color: ${props => props.color};
  border: 2px solid ${props => props.color};
  &:hover {
    background-color: ${props => lighten(contrastDown, props.color as string)};
    color: ${props =>
      readableColor(lighten(contrastDown, props.color as string))};
    border: 2px solid transparent;
  }

  &:active {
    background-color: ${props => darken(contrastUp, props.color as string)};
    color: ${props => readableColor(darken(contrastUp, props.color as string))};
  }
`;
